
import { SistemaMixin } from "@/modules/Application";
import { quantityOptions } from "@/modules/Application";
import { Money } from "v-money";
import { criarLoteNovoCompra } from "@/modules/Compras/loteCompra";

export default {
  name: "LoteModal",
  mixins: [SistemaMixin],
  components: {
    Money,
  },
  props: {
    produto: {
      type: Object,
      default: null,
    },
    addProduto: {
      type: Function,
    },
    compra: {
      type: Boolean,
    },
    atualizarLotes: {
      type: Number,
    },
    preco: {
      type: Number,
      default: 0,
    },
    quantidade: {
      type: [Number, String],
      default: 1,
    },
    bloquearQuantidade: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      filtroLote: "",
      quantityOptions,
      lotes: [],
      loteSelecionado: null,
      quantidadeSelecionada: 1,
      modoLote: "existente",
      opcoesModoLote: [
        { text: "Selecionar lote existente", value: "existente" },
        { text: "Cadastrar novo lote", value: "novo" },
      ],
      novoLote: {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      },
      campos: [
        { key: "numero_lote", label: "Lote" },
        { key: "data_fabricacao", label: "Fabricação" },
        { key: "data_validade", label: "Validade" },
        { key: "quantidade", label: "Disponível" },
      ],
    };
  },
  watch: {
    atualizarLotes(value) {
      this.abrirModal();
    },
  },
  computed: {
    podeConfirmar() {
      const possuiLote = this.modoLote === "novo"
        ? Boolean(this.novoLote.numero_lote?.trim())
        : Boolean(this.loteSelecionado);

      return possuiLote && Number(this.quantidadeSelecionada) > 0;
    },
    lotesFiltrados() {
      let lotes = [...this.lotes];

      lotes = lotes
        .sort((a, b) => new Date(a.data_validade) - new Date(b.data_validade));

      if (this.filtroLote) {
        return lotes.filter((lote) =>
          lote.numero_lote.toLowerCase().includes(this.filtroLote.toLowerCase())
        );
      }

      return lotes;
    },
  },
  methods: {
    selecionarLote(selecionado) {
      if (selecionado.length === 0) {
        this.loteSelecionado = null;
        this.quantidadeSelecionada = 0;
        return;
      }

      const lote = selecionado[0];

      this.loteSelecionado = lote;
      this.quantidadeSelecionada = 1;
    },
    confirmarSelecao() {
      if (!this.compra && this.modoLote === "existente") {
        if (
          this.loteSelecionado.quantidade < this.quantidadeSelecionada
        ) {
          this.$toast.warning(
            "Quantidade informada maior que a do lote selecionado!"
          );
          return;
        }
      }

      if (this.podeConfirmar) {
        const loteSelecionado = this.modoLote === "novo"
          ? criarLoteNovoCompra(this.novoLote, this.quantidadeSelecionada)
          : this.loteSelecionado;

        // Cria uma cópia do lote sem mutar o original
        const loteBaixa = {
          ...loteSelecionado,
          quantidade_original: this.modoLote === "novo"
            ? 0
            : loteSelecionado.quantidade,
          quantidade: this.numberToReal(this.quantidadeSelecionada),
        };
        
        // Cria um novo objeto produto sem mutar a prop
        const produtoAtualizado = {
          ...this.produto,
          lote_baixa: loteBaixa,
          preco: this.formatNumberToFloat(this.produto.preco),
          quantidade: this.quantidadeSelecionada,
        };

        // Usa o preco vindo da prop (preço digitado no form principal) se disponível
        const precoUtilizado = this.preco > 0 ? this.preco : this.formatNumberToFloat(this.produto.preco);
        const totalCalculado = precoUtilizado * this.quantidadeSelecionada;

        this.$emit("onAddProduto", {
          newPreco: precoUtilizado,
          newQuantidade: this.quantidadeSelecionada,
          newTotal: totalCalculado,
          newProduto: produtoAtualizado,
        });

        this.fecharModal();
      }
    },
    async abrirModal() {
      if (!this.produto?.id) return;
      
      this.$nextTick(() => {
        if (this.$refs.modalLote) {
          this.$refs.modalLote.show();
        }
      });
      this.loading = true;
      this.loteSelecionado = null;
      this.modoLote = "existente";
      this.novoLote = {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      };
      this.quantidadeSelecionada = Number(this.quantidade) > 0
        ? Number(this.quantidade)
        : 1;

      try {
        const response = await this.$http.post("/produtos/get-lote", {
          id_produto: this.produto.id,
          compra: this.compra,
        });

        this.lotes = response.data || [];
        this.loading = false;

        if (this.compra && this.lotes.length === 0) {
          this.modoLote = "novo";
        }

        if (
          this.produto?.baixa_automatica_lote &&
          this.lotesFiltrados.length > 0
        ) {
          this.loteSelecionado = this.lotesFiltrados[0];
          this.quantidadeSelecionada = 1;
          this.$toast.success(
            `Lote ${this.loteSelecionado.numero_lote} foi sugerido automaticamente!`
          );
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar lotes do servidor.");
        this.loading = false;
      }
    },
    fecharModal() {
      this.loteSelecionado = null;
      this.quantidadeSelecionada = 0;
      this.filtroLote = "";
      this.modoLote = "existente";
      this.novoLote = {
        numero_lote: "",
        data_fabricacao: null,
        data_validade: null,
      };
      this.$refs.modalLote.hide();
      this.$emit("onClose");
    },
  },
};
